import { useEffect, useRef, useState } from 'react';

export default function useCountUp(target = 0, duration = 800) {
  const [value, setValue] = useState(0);
  const startTime = useRef(null);

  useEffect(() => {
    const start = performance.now();
    startTime.current = start;

    const easeOutCubic = (t) => {
      return (--t) * t * t + 1;
    };

    const step = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeOutCubic(progress);
      setValue(Math.floor(easedProgress * target));
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }, [target, duration]);

  return value;
}

